import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../utils/axios';

export const networkGetProfileDashboard = async () => {
  const res = await axiosInstance.post('Profile/Dashboard');
  return res;
};

export function useFetchProfileDashboard() {
  return useQuery({
    queryKey: ['Profile/Dashboard'],
    queryFn: () => networkGetProfileDashboard(),
  });
}

// ----------------------------------------------------------------------

export const fetchProfileInfo = async () => {
  const res = await axiosInstance.post('Profile/Info/App');
  return res;
};

export function useFetchProfileInfo() {
  return useQuery({
    queryKey: ['profile-info'],
    queryFn: () => fetchProfileInfo(),
    cacheTime: 60 * 60 * 24 * 30,
  });
}

export const networkUpdateProfile = async (payload) => {
  const res = await axiosInstance.post('Profile/Update', payload);
  return res;
};
